import useSWRImmutable from 'swr/immutable'

import { InsuranceCompanyListSchema } from '@/legacy-src/components/insuranceCompanies/schemas'
import { useApis } from '@/legacy-src/contexts/api-context'
import type { ApisType } from '@/legacy-src/store/createApis'

const fetchFunction = async (api: ApisType['api']) => {
  const res = await api.getInsuranceCompanies()

  return InsuranceCompanyListSchema.parse(res.data)
}

const useInsuranceCompanies = () => {
  const { api } = useApis()
  const { data, isLoading } = useSWRImmutable(['useInsuranceCompanies'], () => fetchFunction(api))

  return {
    insuranceCompanies: data,
    isLoading: isLoading,
  }
}

export default useInsuranceCompanies
